import { reactive } from 'vue'
export default reactive({
    player: {}, 
    leaderboard:[]
})
